module.exports = __webpack_public_path__ + "static/media/video.73a83be8.svg";